<!-- 
  顶部组件
 -->
 <template>
  <div class="nav_header" :style="{marginTop:marginTop+'px'}">
    <div class="nav_header_top">
      <div class="ys_content">
        <!-- <span @click="navTo((sysInfo.sys_id==11?'/manager/login/index':'/manager/index/index')+($route.fullPath.indexOf('?')>-1?`?${$route.fullPath.split('?')[1]}`:''),'',true)"><span v-show="sysInfo.sys_id">{{sysInfo.sys_id==11?'游客请登录 | 免费注册':'管理后台'}}</span></span> -->
        <div class="nav_header_topItem active" v-if="!sysInfo.sys_id||sysInfo.sys_id==11">
          <i class="iconfont nav_header_top_icon">&#xe635;</i>
          <span @click="navTo('/manager/login/index'+($route.fullPath.indexOf('?')>-1?`?${$route.fullPath.split('?')[1]}`:''),'',true)">游客请登录</span>&nbsp;|&nbsp; 
          <span @click="$bus.$emit('registerPopup')">免费注册</span>
        </div>
        <div class="nav_header_topItem active" @click="navTo(adminUrl,{},true)" v-else><span>管理后台</span></div>
        <div class="nav_header_topList ys_scrollbar">
          <span class="nav_header_topItem" @click="navTo('/manager/order/orderList','',true)">我的订单</span>
          <span class="nav_header_topItem" @click="navTo('/cart')">
            <i class="iconfont nav_header_top_icon">&#xe615;</i>购物车
          </span>
          <span class="nav_header_topItem" @click="navTo('/manager/goodsNew/goodsList','',true)">
            <i class="iconfont nav_header_top_icon">&#xe628;</i>选品库
          </span>
          <span class="nav_header_topItem" style="color: var(--theme-color);" @click="sysInfo.combo_id==2?toLoginRise():navTo('/index')"><i class="iconfont nav_header_top_icon">&#xe646;</i>选品中心</span>
          <!-- <span class="nav_header_topItem" @click="navTo('http://www2.douhuomall.com/manager/login/index','',true)">返回老版</span> -->
          <span class="nav_header_topItem" @click="onClearChache()">清除缓存</span>
          <span class="nav_header_topItem" style="color: var(--theme-color);"><i class="iconfont nav_header_top_icon">&#xe62b;</i>服务热线：18973183401</span>
        </div>
      </div>
    </div>
    <!-- <el-carousel direction="vertical" indicator-position="none" height="74px" :interval="2000" v-if="sysInfo.sys_id">
      <el-carousel-item v-if="sysInfo.quick_open==1">
        <img src="@/static/nav_ad01.png" alt="" style="width:100%;height:100%;object-fit: cover;cursor: pointer;" @click="navTo('/special',{nav_type:1,id:12},false, false)">
      </el-carousel-item>
      <el-carousel-item>
          <div class="nav_header_ad">
            <div class="ys_content _flex">
              <ul>
                  <li>政企单位集采</li>
                  <li>门店营销礼赠品集采</li>
                  <li>节假日礼品集采</li>
                  <li>&nbsp;&nbsp;单位员工福利集采&nbsp;&nbsp;</li>
              </ul>
              <div class="nav_header_ad_webname">微唯宝集采</div>
              <div class="nav_header_ad_dec">价格更低，效率更高，到货更快</div>
              <div class="nav_header_ad_more" @click="navTo('/about')">立即了解</div>
            </div>
          </div>
      </el-carousel-item>
    </el-carousel> -->
  

    
    <div class="ys_content mobile_nav" v-if="$route.path!='/about'">
      <div class="nav_header_middle">
        <div class="nav_header_left">
          <img class="nav_header_logo" :src="sysInfo.choice_top_logo|setImage" @click="selectNav('index')" v-if="sysInfo.choice_top_logo">
          <img class="nav_header_logo" src="@/static/logo.png" @click="selectNav('index')" v-else>
          <div class="nav_header_logoTips" :style="marginTop>-20?'':'height: 0; overflow: hidden;'">
            <div class="nav_header_logoTipItem"><i class="iconfont nav_header_icon">&#xe658;</i>正品行货</div>
            <div class="nav_header_logoTipItem"><i class="iconfont nav_header_icon">&#xe627;</i>底价供货</div>
            <div class="nav_header_logoTipItem"><i class="iconfont nav_header_icon">&#xe626;</i>品类齐全</div>
          </div>
        </div>
        <div class="nav_header_search">
          <!-- <el-input class="nav_header_input" autocomplete="off" auto-complete="off" name="top_search_input" placeholder="商品名称/商品编码" v-model="searchText" clearable @clear="search(searchType,true)" @keyup.native.enter="search(searchType)">
            <el-select v-model="searchType" slot="prepend" placeholder="请选择">
              <el-option label="商品名称" :value="1"></el-option>
              <el-option label="商品编码" :value="2"></el-option>
            </el-select>
            <el-button slot="append" icon="el-icon-search" v-waves @click="search(searchType)">搜索</el-button>
          </el-input> -->
          <form autocomplete="off" class="nav_header_input">
            <el-select v-model="searchType" placeholder="请选择">
              <el-option label="商品名称" :value="1"></el-option>
              <el-option label="商品编码" :value="2"></el-option>
            </el-select>
            <input v-model="searchText" placeholder="商品名称/商品编码" autocomplete="off" auto-complete="off" name="top_search_input"/>
            <el-button icon="el-icon-search" style="width: 120px;font-size:18px" v-waves @click="search(searchType,!searchText)">搜索</el-button>
          </form>
          <div class="nav_header_searchTips ys_scrollbar">
            <span class="nav_header_tipItem" v-for="(item,index) in hotSearch" :key="index">
              <b v-if="index>0"></b>
              <span class="ys_hover" @click="searchText=item;search(1)">{{item}}</span>
            </span>
          </div>
        </div>
        <div class="nav_header_right">
          <button class="nav_header_btnItem" v-waves @click="navTo('/manager/goodsNew/goodsList','',true)">
            <i class="iconfont nav_header_top_icon" style="height:22px;font-size:24px">&#xe628;</i>选品库
            <span class="nav_header_btnNum" v-if="nums.choice_count>'0'">{{nums.choice_count | setNums}}</span>
          </button>
          <button class="nav_header_btnItem" v-waves @click="navTo('/cart')">
            <i class="iconfont nav_header_top_icon" style="height:22px;font-size:24px">&#xe615;</i>购物车
            <span class="nav_header_btnNum" v-if="nums.cart_count>'0'">{{nums.cart_count | setNums}}</span>
          </button>
        </div>
        <img :src="linkObj.link_img" class="nav_header_img" @click="navTo(linkObj.link_url,{},true)" v-if="linkObj.link_img"/>
      </div>
      <div class="nav_header_nav" ref="navHeader" :style="{marginTop: marginTop>-20?'20px':'0'}">
        <div class="nav_header_navItem nav_header_navItem_first" @mouseenter="navEnter" @mouseleave="navLeave">商品分类
        </div>
        <div class="nav_header_navItem_list ys_scrollbar" ref="scrollRef">
          <div class="nav_header_navItem" v-waves :class="{active:$route.path=='/index'}" @click="selectNav('index')">
            <img src="@/static/top_10.png" class="nav_header_navItem_icon">首页</div>
            <!-- <div class="nav_header_navItem" v-waves :class="{active:$route.path=='/selection'}" @click="selectNav(1)">
            全部商品</div>
          <div class="nav_header_navItem" v-waves :class="{active:selectBar=='virtual'}" @click="selectNav(4)">权益充值
          </div> -->
          <div class="nav_header_navItem" :class="{active:(selectBar==item.nav_id||pid==item.nav_id)}" v-for="(item,index) in navBarList"
            :key="item.nav_id" @click="selectNav(item)" ref="navHeaderItem" @mouseover="onMouseover($event,index,true)" @mouseleave="onMouseover($event,index)">
            <img :src="item.nav_icon" class="baop" v-if="item.icon_type==2">
            <div class="_flex" v-else><img :src="item.nav_icon" class="nav_header_navItem_icon">{{item.nav_name}}</div>
            <div class="child" :style="item.childStyle" v-if="item.child&&item.child.length">
              <div class="child_item" :class="{active:selectBar==row.nav_id}" v-for="(row,key) in item.child" @click.stop="selectNav(row,item)" :key="key">{{row.nav_name}}</div>
            </div>
            </div>
        </div>
        <div class="nav_header_nav_scroll" @click="getNavOffset" v-if="navScrollTo>=50">
          <i :class="navScroll>0?'el-icon-arrow-right':'el-icon-arrow-left'"></i>
        </div>
      </div>
      <!-- 商品分类hover -->
      <div class="nav_header_hover ys_scrollbar" @mouseenter="navChildEnter" @mouseleave="navLeave" v-show="hoverShow">
        <div class="nav_header_hoverLoading" v-loading="hoverLoading">
          <div class="nav_header_hoverItem" :class="{active:hoverIndex===key}" @mouseenter="navItemEnter(item,key)"
            v-for="(item,key) in cateGroupList" :key="key">
            <div v-for="(label,ind) in item.group_name" :key="ind">
              <span class="nav_header_hoverLine" v-if="ind>0">/</span>
              <label class="nav_header_hoverLabel ys_hover"
                @click="sysInfo.combo_id==2?toLoginRise():navTo('/selection',{cate:label.cate_id,name:label.cate_name})">{{label.cate_name}}</label>
            </div>
          </div>
        </div>

        <div class="nav_header_childCon ys_scrollbar" v-loading="hoverChildLoading" v-show="hoverChildShow">
          <div class="nav_header_childLoading" v-loading="hoverChildLoading">
            <div class="nav_header_childItem" v-for="(childItem,childIndex) in cateGoryList" :key="childIndex">
              <div class="nav_header_childTitle">
                <span class="ys_hover"
                  @click="sysInfo.combo_id==2?toLoginRise():navTo('/selection',{cate:childItem.cate_id,name:childItem.cate_name})">{{childItem.cate_name}}</span>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="nav_header_childList">
                <span class="ys_hover nav_header_childText" v-for="(child,index) in childItem.child" :key="index"
                  @click="sysInfo.combo_id==2?toLoginRise():navTo('/selection',{cate:child.cate_id,name:child.cate_name})">{{child.cate_name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getCateGroup,
    getCategory,
    getNaviSpecial,
    updateChoice,
    getHotSearch,
    getLink,clearCache
  } from '@/api/common'

  import {
    debounce
  } from '@/utils/plugins'
  import {
    sendMsg,
    getMsg
  } from '@/utils/crossTagMsg'
  import {mapActions,mapState} from 'vuex'
  export default {
    name: 'NavHeader',
    data() {
      return {
        searchType: 1,//搜索类型
        searchText: '', //搜素内容
        hoverShow: false, //是否显示一级分类
        hoverLoading: false, //loading一级分类
        hoverChildShow: false, //是否显示二级分类
        hoverChildLoading: false, //loading二级分类

        cateGroupList: [], //一级分类
        cateGoryList: [], //展示的二级分类
        hoverIndex: '', //当前hover一级分类下标
        navBarList: [], //自定义选项卡
        hotSearch: [], //热搜词
        selectBar: '',
        nums: {
          choice_count: 0,
          limit_count: 0,
          margin_count: 0,
          update_count: 0,
          cart_count: 0
        },
        navScrollTo : 0,
        navScroll : 0,
        marginTop : 0,
        linkObj : {},
        adminUrl : window.location.origin+'/manager/index/index'
      }
    },
    watch: {
      $route(val) {
        this.initActive()
      }
    },
    computed:{
      ...mapState(['sysInfo','userInfo']),
      pid(){
        if(this.navBarList){
          let parent = this.navBarList.find(item=>item.child.some(row=>row.nav_id==this.$route.query.id))||{};
          return parent.nav_id;
        }
      }
    },
    filters: {
      setNums(num) {
        return num > 99 ? '99+' : num;
      }
    },
    mounted() {
      //事件监听
      this.$bus.$on('headerChange', ({
        type,
        params
      }) => {
        if (type == 'data') {
          for (let key in params) {
            this[key] = params[key]
          }
        }else if(type=='addCart'){
          this.updateChoice()
        }
      })
      this.initActive()
      this.init()
      this.getNavOffset()
      this.getSystemConfig();
      this.getLink();
      this.onClearChache('@ysnavBarList')
      setTimeout(()=>{
        let version = this.sysInfo.version||'0';
        if(version!==localStorage.getItem('@ys_system_version')){
          this.onClearChache('all')
          localStorage.setItem('@ys_system_version',version)
        }
      },500)
    },
    methods: {
      ...mapActions(['getSystemConfig']),
      getLink(){
        getLink().then(({result})=>{
          this.linkObj = result[0]||{}
        })
      },
      getNavOffset(){
        this.$nextTick(()=>{
            let navW    = this.$refs.scrollRef.offsetWidth;
            let navItemT=0,navItemW=0;
            document.querySelectorAll('.nav_header_navItem_list .nav_header_navItem').forEach(item=>{
              navItemT += item.clientWidth;
              navItemW  = item.clientWidth;
            })
            this.navScrollTo  = navItemT-navW;
            this.$refs.scrollRef.scrollTo(this.navScroll,navItemT);
            this.navScroll += navItemW;
            if(this.navScroll>(this.navScrollTo+navItemW)){
              this.navScroll = 0;
            }
        })
      },
      // 初始化
      init() {
        let cateGroupSave = getMsg('cateGroupList') || '';
        if (cateGroupSave && cateGroupSave.payload.length && Date.now() - cateGroupSave.temp < 1 * 60 * 60 * 1000) {
          //分类获取缓存 1小时内不更新
          this.cateGroupList = cateGroupSave.payload
        }

        let navBarSave = getMsg('navBarList') || '';
        if (navBarSave && navBarSave.payload.length && Date.now() - navBarSave.temp < 1) {
          //获取导航选项卡 1小时内不更新（1 * 60 * 60 * 1000）
          this.navBarList = navBarSave.payload
        } else {
          //获取导航选项卡
          getNaviSpecial().then(res => {
            if (res.error_code == 0) {
              this.navBarList = res.result;
              sendMsg('navBarList', this.navBarList, 'NavHeader')
            }
          })
        }
        let hotSearch = getMsg('hotSearch') || '';
        if (hotSearch && hotSearch.payload.length && Date.now() - hotSearch.temp < 1 * 60 * 60 * 1000) {
          //获取热搜词 1小时内不更新
          this.hotSearch = hotSearch.payload
        } else {
          //获取热搜词
          getHotSearch({
            cate_id: 0,
            limit: 10
          }).then(res => {
            if (res.error_code == 0) {
              this.hotSearch = res.result;
              sendMsg('hotSearch', this.hotSearch, 'NavHeader')
            }
          })
        }
        this.updateChoice()
      },
      updateChoice(){
        //获取统计数字
        setTimeout(()=>{
            updateChoice({
              type: 0
            }).then(res => {
              if (res.error_code == 0) {
                this.nums = res.result;
                sendMsg('nums', this.nums, 'NavHeader')
              }
            })
        },5000)
      },
      /**
       * 父级调用更新页面数据
       * */
      initSave({
        key,
        params
      }) {
        this[key] = params;
      },
      /**
       * 选项卡选中
       * */
      initActive() {
        this.selectBar = this.$route.query.id;
      },
      /**
       * 搜素 type 1商品名称搜索 2商品编码搜索
       * isClear true input清除事件
       * */
      search(type,isClear=false) {
        if(this.sysInfo.combo_id==2){
          return this.$message.error('权限不足！请联系商务~');
        }
        if(this.searchText.length<2&&!isClear){
          return this.$message.warning('搜索关键词不能少于两个字');
        }
        this.searchType = type;
        if(this.$route.path == '/local'){
          this.$nextTick(() => {
            this.$bus.$emit('localSelectionSearch', {
              val: {
                type,
                text: this.searchText
              }
            })
          })
        }else if(this.$route.path != '/selection' && this.$route.path != '/topic'){
          if(this.$route.query.nav_type==4){
            this.navTo('/topic', {
              nav_type : 4,
              id : 4,
              text: this.searchText,
              type
            },false,false)
          }else{
            this.navTo('/selection', {
              text: this.searchText,
              type
            })
          }
        }else{
          this.$nextTick(() => {
            this.$bus.$emit('selectionSearch', {
              type: 'headerSearch',
              val: {
                type,
                text: this.searchText
              }
            })
          })
        }
      },
      /**
       * 商品分类鼠标事件
       * */
      navEnter(e) {
        this.hoverShow = true;
        if (!this.hoverLoading && this.cateGroupList.length == 0) {
          this.hoverLoading = true;
          getCateGroup({
            page: 0,
            limit: 0
          }).then(res => {
            this.hoverLoading = false;
            if (res.error_code == 0) {
              let list = res.result;
              list.forEach(item => {
                item.child = [];
              })
              this.cateGroupList = list;
              sendMsg('cateGroupList', list, 'NavHeader')
            }
          }).catch(() => {
            this.hoverLoading = false;
          })
        }
      },
      navLeave(e) {
        this.hoverShow = false;
        this.hoverChildShow = false;
        this.hoverIndex = ''
      },
      /**
       * 商品分类子元素鼠标事件
       * */
      navChildEnter(e) {
        this.hoverShow = true;
      },
      /**
       * 商品分类子元素移入获取数据
       * */
      navItemEnter(item, index) {
        this.hoverIndex = index;
        this.hoverChildShow = true;
        if (item.child.length) {
          this.hoverChildLoading = false;
          this.cateGoryList = this.cateGroupList[this.hoverIndex].child;
        } else {
          this.hoverChildLoading = true;
          this.cateGoryList = []
          this.getCategory(item)
        }
      },
      /**
       * 获取子分类
       * */
      getCategory: debounce(function(item) {
        getCategory({
          cate_pid: item.cate_pid,
          group_id: item.group_id
        }).then(res => {
          if (res.error_code == 0) {
            item.child = res.result.cate_list;
            if (this.cateGroupList[this.hoverIndex].group_id == item.group_id) {
              this.hoverChildLoading = false;
              this.cateGoryList = this.cateGroupList[this.hoverIndex].child;

              sendMsg('cateGroupList', this.cateGroupList, 'NavHeader')
            }
          }
        }).catch(() => {
          this.hoverChildLoading = false;
        })
      }),
      onMouseover(e,index,show=false){
        this.$set(this.navBarList[index],'childStyle',{})
        if(show){
          let parent = this.$refs.navHeader.getBoundingClientRect();
          let child = this.$refs.navHeaderItem[index].getBoundingClientRect();
          this.navBarList[index].childStyle = {
            display: 'block',
            left : `${child.left - parent.left}px`
          };
        }
      },
      onSetHeight(e){
        this.marginTop  = e>=160 ? -160 : -e;
      },
      onClearChache(type){
        if(!type || type=='all'){
          clearCache()
          localStorage.clear()
          if(!type){
            this.$message.success('缓存清除成功')
          }
        }else if(type){
          localStorage.removeItem(type)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .nav_header {
    width: 100%;
    background-color: #fff;
    border-bottom: 1px solid #e6e6e6;
    --navItem-first: 200px;

    // 顶部
    &_top {
      padding: 10px 0;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #e6e6e6;
      // background-color: #F0F0F0;
      &_icon{
        margin-right: 4px;font-size: 20px;color: var(--theme-color);height: 26px;
      }
      .ys_content {
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      span {
        flex-shrink: 0;
        cursor: pointer;
        user-select: none;
      }
    }

    &_ad{
      height: 74px;
      background-image: url('@/static/nav_ad.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      color: #fff;
      ._flex{
        height: 100%;
      }
      ul{
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        width: 300px;
        li{
          min-width: 120px;
          text-align: center;
          padding: 0 10px;
          margin: 3px;
          background-color: #fff;
          border-radius: 5px;
          color: #FE6E3D;
          font-size: 14px;
        }
      }
      &_webname{
        font-size: 34px;
        font-weight: 600;
      }
      &_dec{
        font-size: 22px;
        margin-left: -60px;
      }
      &_more{
        text-align: center;
        font-size: 18px;
        width: 150px;
        line-height: 35px;
        background: linear-gradient(0deg, #FF2442 0%, #FD7E3E 100%);
        border-radius: 21px;
        border: 2px solid #FFFFFF;
        cursor: pointer;
      }
    }

    &_topList {
      height: 100%;
      display: flex;
      align-items: center;
      // overflow-x: auto;
    }

    &_topItem {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      padding: 5px 15px;
      white-space: nowrap;
      position: relative;
      margin: 0 10px;

      &~&::before {
        content: '';
        position: absolute;
        left: -10px;
        top: 50%;
        width: 1px;
        height: 8px;
        margin-top: -4px;
        background-color: #ccc;
      }

      [class^=el-icon-],
      [class^=icon-] {
        font-size: 15px;
        color: var(--theme-color);
        margin-right: 4px;
      }

      &:not(:last-child):hover ,&.active{
        color: var(--theme-color);
        background-color: #FFD3D9;
        border-radius: 6px;
      }

      &:last-child {
        cursor: default;
        user-select: text;
      }
    }

    // 中间部分 搜索
    &_middle {
      display: flex;
      padding-top: 25px;
    }

    &_left {
      flex-shrink: 0;
      width: 308px;
    }

    &_logo {
      display: block;
      width: 200px;
      cursor: pointer;
    }

    &_logoTips {
      display: flex;
      align-items: center;
      margin-top: 12px;
      transition: all .1s;
    }

    &_logoTipItem {
      display: flex;
      align-items: center;
      height: 24px;
      font-size: 13px;
      color: #999;
      position: relative;
      // background: url('~@/static/header-tip1.png') 0 center no-repeat;
      // background-size: 19px auto;

      // &:nth-child(2) {
      //   background-image: url('~@/static/header-tip2.png');
      // }

      // &:nth-child(3) {
      //   background-image: url('~@/static/header-tip3.png');
      // }

      &~& {
        margin-left: 15px;
      }
    }

    &_icon{
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border: 1px solid #999;
      border-radius: 50%;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &_search {
      flex: 1 0 0;
    }

    &_input {
      height: 50px;
      border-color: var(--theme-color);
	    display: flex;
      border:1px solid var(--theme-color);
      border-radius: 6px;
      overflow: hidden;
      input{
        flex: 1 0 0;
        font-size: 14px;
        color: #333;
        height: 48px;
        line-height: 48px;
        outline: none;
        border-color: #fff0;
        padding: 0 15px;
      }
      ::v-deep {
        .el-input__inner{
          width: 110px;
          height: 48px;
          color: #999;
          font-size: 14px;
        }
        .el-input.is-focus .el-input__inner,.el-select .el-input__inner{
          border-color: #fff0;border-radius: 0;
          // border-right: 1px solid var(--theme-color);
        }
        .el-button {
          height: 100%;
          margin: 0;
          border: none;
          color: #fff;
          background-color: var(--theme-color);
        }
      }
    }

    &_searchTips {
      height: 24px;
      overflow: hidden;
      margin-top: 12px;
    }

    &_tipItem {
      display: inline-block;
      font-size: 14px;
      color: #999;
      line-height: 24px;

      b {
        display: inline-block;
        width: 1px;
        height: 12px;
        font-weight: 400;
        margin: 0 8px;
        // background-color: #999;
        vertical-align: text-top;
      }
    }

    &_right {
      flex-shrink: 0;
      margin-left: 30px;
      display: flex;
    }
    &_img{
      height: 64px;margin-left: 50px;cursor: pointer;
    }
    &_btnItem {
      display: flex;
      align-items: center;
      min-width: 140px;
      height: 50px;
      padding: 0 15px;
      font-size: 18px;
      color: #333;
      border-radius: 10px;
      // background-color: #f5f5f5;
      border: 1px solid var(--theme-color);
      cursor: pointer;
      background: #fff0;
      &~& {
        margin-left: 20px;
      }

      [class^=el-icon-],
      [class^=icon-] {
        font-size: 24px;
        color: #808080;
        margin-right: 4px;
      }
    }

    &_btnNum {
      height: 18px;
      min-width: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 5px;
      border-radius: 100px;
      font-size: 12px;
      color: #fff;
      margin-left: 9px;
      background-color: var(--theme-color);
    }

    // 导航部分
    &_nav {
      display: flex;
      margin-top: 20px;
      height: 65px;
      position: relative;
      transition: all .1s;
      &_scroll{
        position: absolute;
        right: 0;
        background-color: #fff;
        cursor: pointer;
        line-height: 44px;
      }
    }

    &_navItem {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 140px;
      font-size: 20px;
      font-weight: 600;
      cursor: pointer;

      &_list {
        flex: 1 0 0;
        display: flex;
        justify-content: space-between;
        overflow-x: auto;
      }

      &:hover,
      &.active{
        color: var(--theme-color);
      }
      &:hover{
        .child{
          display: block;
        }
      }
      &_first {
        width: var(--navItem-first);
        background-color: var(--theme-color);
        color: #fff;
        border-radius:10px 10px 0 0;
        font-size: 22px;
        &:hover {
          color: #fff;
        }
      }
      
      .child{
        display: none;
        position: absolute;
        top: 60px;
        width: inherit;
        min-width: 140px;
        z-index: 9999;
        text-align: center;
        line-height: 40px;
        background-color: #fff;
        box-shadow: 0 8px 5px 0 #0000002e;
        color: #000;
        font-size: 16px;
        border-radius: 6px;
        font-weight: 400;
        overflow: hidden;
      }
      .child_item{
        border-top: 1px solid #f5f5f5;
        padding: 10px 0;
        &:hover,
        &.active {
          color: var(--theme-color);
          // transform: scale(1.05);
          font-weight: bold;
        }
      }
      &_icon{
        width: 24px;height: 24px;margin-right: 5px;
      }
      .baop{
        max-height: 50%;max-width: 125px;
      }
    }

    &_hover {
      position: absolute;
      left: 0;
      top: 100%;
      width: var(--navItem-first);
      min-height: 300px;
    }

    &_hoverLoading {
      height: 100%;
      position: relative;
      z-index: 5;
    }

    &_hoverItem {
      display: flex;
      align-items: center;
      width: var(--navItem-first);
      min-height: 44px;
      padding: 5px 20px 5px 28px;
      font-size: 14px;
      color: #fff;
      line-height: 16px;
      background-color: var(--theme-color);
      border: 1px solid var(--theme-color);
      border-right: none;
      cursor: pointer;
      flex-wrap: wrap;
      &:hover,
      &.active {
        background-color: #fff;
        color: var(--theme-color);
      }
    }

    &_hoverLine {
      font-size: 14px;
      padding: 0 1px;
      vertical-align: middle;
    }

    &_childCon {
      position: absolute;
      left: 100%;
      top: 1px;
      width: 1100px;
      height: calc(100% - 1px);
      background-color: #fff;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
      overflow-y: auto;
    }

    &_childLoading {
      display: block;
      width: 100%;
      height: 100%;
      padding: 10px 0;
    }

    &_childItem {
      display: flex;
      font-size: 14px;
      color: #333;
      line-height: 22px;
      padding: 8px 20px;
    }

    &_childTitle {
      width: 92px;
      flex-shrink: 0;
      padding: 0 20px 0 10px;
      font-weight: bold;
      position: relative;

      >span {
        word-break: break-all;
      }

      .el-icon-arrow-right {
        position: absolute;
        right: 0;
        top: 5px;
        font-weight: 400;
      }
    }

    &_childList {
      flex: 1 0 0;
      display: flex;
      flex-wrap: wrap;
    }

    &_childText {
      padding: 0 10px;
    }
  }

  ._flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  @media (max-width: $mediaWidth) {
    .mobile_nav{
      .nav_header_navItem{
        width: 92px!important;
      }
    }
    .nav_header{
      &_nav{
        height: 60px;
      }
      &_childCon {
        width: calc(998px - var(--navItem-first));
      }
      &_navItem{
        font-size: 18px;
        min-width: 119px;
        // &:not(.nav_header_navItem_first){
        //   width: 99px;
        // }
        &_icon{
          width: 20px;height: 20px;
        }
        .baop{
          max-height: 43%;max-width: 110px;
        }
      }
      &_ad{
        ul{
          width: 270px;
          li{
            min-width: 110px;
            font-size: 12px;
          }
        }
        &_webname{
          font-size: 28px;
        }
        &_dec{
          font-size: 18px;
        }
        &_more{
          width: 140px;
          line-height: 35px;
        }
      }
    }
  }
</style>
